module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-3-c5c9f7eab6875a65bd51635b55beb5c4.gif";